import { Svg } from 'components/svg'
import { IconType } from 'models'

export const IconHome: IconType = ({ className = '' }) => (
  <Svg className={className} viewBox="0 0 20 20" fill="none">
    <path
      id="home / home_alt_fill"
      d="M0 10.2892L9.293 1.11403C9.6835 0.728593 10.3165 0.728593 10.707 1.11403L20 10.2892H18V18.1878C18 18.7331 17.5523 19.1752 17 19.1752H12V12.2639H8V19.1752H3C2.44772 19.1752 2 18.7331 2 18.1878V10.2892H0Z"
      fill="#1A3948"
    />
  </Svg>
)
